import { useState } from "react"
import { useLocation } from "react-router-dom"
import { useBrukerContext } from "../BrukerContext"

const navLenker = [
    { href: "/leie", tekst: "Leie" },
    { href: "/praktisk-info", tekst: "Praktisk info" },
    { href: "/huskeliste", tekst: "Ankomst & avreise" },
    { href: "/anbefalinger", tekst: "Anbefalinger" },
]

export function TopHeaderMenu() {
    const [visMeny, setVisMeny] = useState(false)
    const { bruker } = useBrukerContext()
    const location = useLocation()

    const erAktiv = (href: string) => location.pathname.startsWith(href)

    return (
        <div className="headerContainer">
            <div className="headerContent">
                <div className="headerVenstre">
                    <a className="backButtonText" href="/">
                        Forside
                    </a>
                    <nav className="navLinker">
                        {navLenker.map((lenke) => (
                            <a
                                key={lenke.href}
                                className={
                                    erAktiv(lenke.href)
                                        ? "navLenke navLenkeAktiv"
                                        : "navLenke"
                                }
                                href={lenke.href}
                            >
                                {lenke.tekst}
                            </a>
                        ))}
                    </nav>
                </div>
                <div className="nameAndMenu">
                    <p className="brukerTekst">
                        <span className="brukerPrefix">Innlogget som: </span>
                        <strong>{bruker}</strong>
                    </p>
                    <div
                        className="burgerMenu"
                        onClick={() => setVisMeny(!visMeny)}
                    >
                        <span className="burgerLine" />
                        <span className="burgerLine" />
                        <span className="burgerLine" />
                    </div>
                </div>
            </div>
            {visMeny && (
                <div className="menu">
                    {navLenker.map((lenke) => (
                        <a
                            key={lenke.href}
                            className={
                                erAktiv(lenke.href)
                                    ? "menuElement menuElementAktiv"
                                    : "menuElement"
                            }
                            href={lenke.href}
                            onClick={() => setVisMeny(false)}
                        >
                            {lenke.tekst}
                        </a>
                    ))}
                </div>
            )}
        </div>
    )
}
